import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';
import { MergeField } from '../../decorators/decorators/merge.field';
import { MergeSchema } from '../../decorators/decorators/merge.schema';
import { getSchema } from '../../decorators/utilities/get.merge.schema';
import { StageMergeData } from './stage.merge.data';
import { StageItemMergeData } from './stage.items.merge.data';
import { AssetMergeData } from './asset.merge.data';

@MergeSchema({
    entity: ActivityEntityName.Asset,
})
export class JobAssetsMergeData {
    @MergeField({
        arraySchemaName: 'AssetMergeSchema'
    })
    assets: AssetMergeData[] = [];
}

export const JobAssetsMergeSchema = getSchema(JobAssetsMergeData)